// @flow
import app from 'app/common/lib/app';
import camelCaseToUnderscore from 'app/common/lib/util/camelCaseToUnderscore';
import store from 'app/common/redux/store/singleton';

export default function getInitModuleName(): ?string {
  if (app.instance) {
    const moduleName = app.instance.initModule.className;
    return camelCaseToUnderscore(moduleName);
  } else {
    const componentName = store.instance.getState().ui.mainComponent.initial;
    if (componentName) {
      return camelCaseToUnderscore(componentName);
    }
  }
  return null;
}
